// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gwata","inputWrap":"Table_inputWrap__rAKpo","col":"Table_col__2Dvo6","bmiTooltip":"Table_bmiTooltip__Aa1iz"};